import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const htmlElement = document.documentElement;
    const originalScrollBehavior = htmlElement.style.scrollBehavior;
    htmlElement.style.scrollBehavior = 'auto';
    const timeouts: Array<ReturnType<typeof setTimeout>> = [];
    let animationFrame = 0;

    const scrollToHashTarget = () => {
      if (!hash) return false;

      const targetId = decodeURIComponent(hash.slice(1));
      const target = document.getElementById(targetId);
      if (!target) return false;

      const navOffset = 80;
      const targetPosition = target.getBoundingClientRect().top + window.scrollY - navOffset;
      window.scrollTo(0, Math.max(targetPosition, 0));
      return true;
    };

    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    const restoreScrollBehavior = () => {
      htmlElement.style.scrollBehavior = originalScrollBehavior;
    };

    animationFrame = window.requestAnimationFrame(() => {
      if (!hash) {
        scrollToTop();
        timeouts.push(setTimeout(restoreScrollBehavior, 80));
        return;
      }

      if (scrollToHashTarget()) {
        timeouts.push(setTimeout(restoreScrollBehavior, 80));
        return;
      }

      [100, 250].forEach((delay) => {
        timeouts.push(setTimeout(scrollToHashTarget, delay));
      });
      timeouts.push(setTimeout(restoreScrollBehavior, 300));
    });

    return () => {
      window.cancelAnimationFrame(animationFrame);
      timeouts.forEach(clearTimeout);
      htmlElement.style.scrollBehavior = originalScrollBehavior;
    };
  }, [pathname, hash]);

  return null;
};
